export const NOTIFICACTIONS_MANAGER_STATE = 'notificationsManagerEmail';

export const FREQUENCY_DAILY = 'daily';
export const FREQUENCY_WEEKLY = 'weekly';
export const FREQUENCY_DISABLED = 'never';



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/constants.js